import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import AddNewProduct from './AddNewProduct.jsx';

/**
 * AddProductPage - Full-page wrapper for the AddNewProduct form.
 * Navigates to /inventory when the form is closed or submitted.
 */
const AddProductPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/inventory');
  };

  return (
    <Box
      sx={{
        padding: '24px 32px',
        maxWidth: '1400px',
        margin: '0 auto',
        width: '100%',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          marginBottom: '20px',
          color: '#2E3C54',
          fontFamily: '"Source Sans Pro", sans-serif',
        }}
      >
        Add New Product
      </Typography>
      <AddNewProduct onClose={handleClose} />
    </Box>
  );
};

export default AddProductPage;
